const pipelines = [
  { name: "Object Detection", path: "od" },
  { name: "Image Pipeline", path: "imagepipeline" },
  { name: "ImageFoolbox Pipeline", path: "imagefoolbox" },
  { name: "Text Pipeline", path: "text" },
  { name: "Structured Pipeline", path: "structured" },
  { name: "Regression Pipeline", path: "regression" },
  { name: "Audio Pipeline", path: "audio" },
  { name: "Timeseries Pipeline", path: "timeseries" },
  { name: "Segmentation Pipeline", path: "segmentation" },
  { name: "Recommendation Pipeline", path: "recommendation" },
];

// Use the ENV variable but ensure it ends with a slash
export const S3UrlHead  = process.env.REACT_APP_S3_HEAD || "https://storage.googleapis.com/aiensured-static-report/ai.datasets/lab/";

/* -------------------------------------------------- */
/* Fetch Data For Each Pipeline */
/* -------------------------------------------------- */
const fetchPipelineData = async (pipeline) => {
  try {
    // Try the double nested path first
    let url = `https://storage.googleapis.com/aiensured-static-report/ai.datasets/lab/${pipeline.path}/${pipeline.path}/results.json`;
    let isNestedPath = true;
    
    console.log(`Fetching ${pipeline.name} from: ${url}`);
    
    let response = await fetch(url, { 
      method: 'GET', 
      mode: 'cors',
      headers: {
        'Accept': 'application/json'
      }
    });
    
    if (!response.ok) {
      if (response.status === 404) {
        // Fallback to single nested path
        url = `https://storage.googleapis.com/aiensured-static-report/ai.datasets/lab/${pipeline.path}/results.json`;
        isNestedPath = false;
        console.log(`Fallback fetching ${pipeline.name} from: ${url}`);
        response = await fetch(url, { 
          method: 'GET', 
          mode: 'cors',
          headers: {
            'Accept': 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    }
    
    const data = await response.json();
    return { pipeline, data, isNestedPath };
  } catch (error) {
    // Check if error is specifically a CORS/Network error
    if (error.message === 'Failed to fetch') {
      console.error(`CORS or Network error for ${pipeline.name}. Check GCP Bucket CORS settings.`);
    } else {
      console.error(`Error fetching ${pipeline.name}:`, error.message);
    }
    return { pipeline, data: null, isNestedPath: true };
  }
};


/* -------------------------------------------------- */
/* Create UI Item */
/* -------------------------------------------------- */
const createItem = (itemData, index, pipeline, isNestedPath) => {
  // Use a stable random seed if possible, otherwise UI will flicker on every re-render
  const randomDays = Math.floor(Math.random() * 30);
  const timestamp = new Date();
  timestamp.setDate(timestamp.getDate() - randomDays);

  const itemName = typeof itemData === "string" 
    ? itemData 
    : (itemData.name || itemData.title || itemData.dataset_name || `Item${index}`);

  return {
    name: itemName.replace(/_/g, " "),
    timestamp: timestamp.toISOString(),
    pipeline: pipeline.name,
    path: pipeline.path,
    dataset: itemName,
    isNestedPath,
  };
};

/* -------------------------------------------------- */
/* Get All Results */
/* -------------------------------------------------- */
export const AllResults = async () => {
  try {
    const results = await Promise.all(pipelines.map(fetchPipelineData));
    
    return results.flatMap(({ pipeline, data, isNestedPath }) => {
      if (!data) return [];

      // Handle common GCP JSON nesting patterns
      const items = Array.isArray(data)
        ? data
        : (data.results || data.items || data.objects || data.data || []);
        
      return items.map((item, i) => createItem(item, i, pipeline, isNestedPath));
    });

    // console.log("Final Combined Results:", finalData);

    return results;
  } catch (error) {
    console.error("Critical error in AllResults:", error);
    return [];
  }
};